import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./homeScreen.scss";
import { AppImages } from "../../AppData/appImages";
import {
  reset,
  setAllItems,
  setMenu,
  setPopular,
  setRecommendations,
  setRestaurentCode,
  setRestaurentInfo,
  setShowMenu,
  setTableNumber,
} from "../../redux/reducers/homeReducer";
import { fetchMenuData } from "../../Services/menuService";
import { decription, prepareWholeMenuItems } from "../../utils/helper";
import hotelList from "../../utils/hotelList";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const HomeScreen = (props) => {
  let params = useQuery();
  let restaurentcode = params.get("rcode");
  let tableNumbers = params.get("tn");
  localStorage.setItem("rcode", String(restaurentcode));
  localStorage.setItem("tn", String(tableNumbers));
  let exRoomNumber = params.get("roomNumber") || "";
  let exLastName = params.get("lastName") || "";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedLanguage = useSelector(
    (state) => state?.homePage?.selectedLanguage
  );
  const tableNumber = useSelector((state) => state?.homePage?.tableNumber);
  const restaurantInfo = useSelector(
    (state) => state?.homePage?.restaurantInfo
  );

  const [menuError, setMenuError] = useState();

  useEffect(() => {
    if (window?.location?.href?.includes("emenu-wait")) {
      localStorage.setItem("waitingUser", "true");
      localStorage.setItem("initialWaitingUser", "true");
    } else {
      localStorage.setItem("waitingUser", "false");
      localStorage.setItem("roomNumber", "false");
      localStorage.setItem("initialWaitingUser", "false");
    }
    if (exRoomNumber) {
      // console.log('exRoomNumber', decription(exRoomNumber));
      let exRoomNumberTemp = decription(exRoomNumber);
      localStorage.setItem("exRoomNumber", exRoomNumberTemp);
    } else {
      localStorage.setItem("exRoomNumber", "");
    }
    if (exLastName) {
      // console.log('exLastName', decription(exLastName));
      let exLastNametemp = decription(exLastName);
      localStorage.setItem("exLastName", exLastNametemp);
    } else {
      localStorage.setItem("exLastName", "");
    }
  }, []);

  useEffect(() => {
    dispatch(reset());
    dispatch(setRestaurentCode(restaurentcode));
    dispatch(setTableNumber(Number(tableNumbers)));

    let timeout;
    const fetchData = async () => {
      try {
        const data = await fetchMenuData(selectedLanguage.key);
        console.log("menuData", data);
        if (data.success == false) {
          setMenuError(data.error.message);
        } else {
          setMenuError("");

          dispatch(setMenu(data?.menu));
          dispatch(setShowMenu(data?.showMenu));
          dispatch(setRestaurentInfo(data?.info));
          // timeout = setTimeout(() => {
          if (data?.info?.Only_payment) {
            navigate("/orders");
          } else {
            navigate("/select-cat");
          }
          // }, 3000);

          const dataPrepared = prepareWholeMenuItems(
            data?.menu?.length > 0
              ? data?.menu[0]?.menu_sections
              : data?.showMenu[0]?.menu_sections
          );
          dispatch(setAllItems(dataPrepared.wholeMenuItems));
          dispatch(setRecommendations(dataPrepared.recommendedItems));
          dispatch(setPopular(dataPrepared.popularItems));
          dispatch(setRestaurentInfo(data?.info));
        }
      } catch (erorr) {
        console.log("erororororor");
        navigate("/site-down");
      }
    };
    fetchData();
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return (
    <div
      className="fullScreen backgroundImage"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${AppImages.bgHome})`,
      }}
    >
      <div className="main-container">
        <div className="brandLogo">
          <img src={AppImages.brandLogo} alt="brand-logo" />
        </div>
        <div className="page-content">
          <h2 className="page-title">
            {/* {restaurantInfo?.restaurant_location
              ? restaurantInfo?.restaurant_location
              : params.get("rcode")} */}
            {hotelList[`${restaurentcode}`]?.name || ""}
          </h2>
          <p className="page-desc">
            {/* {restaurantInfo?.restaurant_name} */}
            {hotelList[`${restaurentcode}`]?.location || ""}
          </p>
          {/* <p className="small-text">Table #{tableNumber}</p> */}
          &nbsp;
          <p className="small-text">{menuError ? menuError : " "}</p>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
